import { Settings } from "../types/settings";

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export const formatCurrency = (amount: number, settings: Settings): string => {
  return `${settings.currencySymbol}${amount.toFixed(
    settings.currencyRounding
  )}`;
};
